import React, { useState } from 'react';

interface DeleteWarningProps {
  itemType: string;
  itemName: string;
  onConfirm: () => Promise<void>;
  onCancel: () => void;
}

const DeleteWarning: React.FC<DeleteWarningProps> = ({ itemType, itemName, onConfirm, onCancel }) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleConfirm = async () => {
    setIsLoading(true);
    try {
      await onConfirm();
      onCancel()
    } catch (error) {
      console.error('Error during confirm action:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="delete-warning">
      <h3>Advertencia</h3>
      <p>
        ¿Estás seguro de que deseas eliminar {itemType}{' '}
        <strong>{itemName}</strong>? Esta acción no se puede deshacer.
      </p>
      <div className="delete-warning__actions">
        <button
          onClick={onCancel}
          className="delete-warning__cancel"
          disabled={isLoading}
        >
          Cancelar
        </button>
        <button
          onClick={handleConfirm}
          className="delete-warning__confirm"
          disabled={isLoading}
        >
          {isLoading ? 'Eliminando...' : 'Confirmar'}
        </button>
      </div>
    </div>
  );
};

export default DeleteWarning;
